if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
      this.userInteracted = false;
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      
      // Adiciona listener para interação do usuário (Chrome Android)
      this.setupUserInteractionListener();
      
      this.initSlider();
    }

    setupUserInteractionListener() {
      const playOnInteraction = () => {
        if (!this.userInteracted) {
          this.userInteracted = true;
          // Tenta reproduzir o vídeo atual após a primeira interação
          this.playCurrentVideo();
          
          // Remove os listeners após a primeira interação
          document.removeEventListener("touchstart", playOnInteraction);
          document.removeEventListener("click", playOnInteraction);
          document.removeEventListener("scroll", playOnInteraction);
        }
      };
      
      // Listeners para diferentes tipos de interação
      document.addEventListener("touchstart", playOnInteraction, { once: true, passive: true });
      document.addEventListener("click", playOnInteraction, { once: true });
      document.addEventListener("scroll", playOnInteraction, { once: true, passive: true });
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        breakpoints: {
          992: {
            threshold: 2,
          },
        },
        on: {
          init: () => {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
            // Reproduz o vídeo do primeiro slide na inicialização
            this.playCurrentVideo();
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;
      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    playCurrentVideo() {
      if (!this.slider) return;
      
      const { activeIndex, slides } = this.slider;
      const currentSlide = slides[activeIndex];
      
      if (!currentSlide) return;
      
      const slideType = currentSlide.dataset.slideType;
      
      if (slideType === "video_slide") {
        const video = currentSlide.querySelector("video");
        
        if (video) {
          // Pausa o vídeo anterior
          if (this.lastVideo && this.lastVideo !== video) {
            this.lastVideo.pause();
          }
          
          // Tenta reproduzir o vídeo atual
          // No Chrome Android, precisa ser muted para autoplay funcionar
          video.muted = true;
          
          let playPromise = video.play();
          
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            }).catch((error) => {
              // Se falhar, tenta novamente após um pequeno delay
              console.log("Autoplay bloqueado, tentando novamente:", error);
              setTimeout(() => {
                video.play().catch(() => {
                  console.log("Autoplay ainda bloqueado, aguardando interação do usuário");
                });
              }, 100);
            });
          }
        }
      } else {
        // Se não é um slide de vídeo, pausa qualquer vídeo anterior
        if (this.lastVideo) {
          this.lastVideo.pause();
          this.lastVideo = null;
        }
      }
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideType = slides[activeIndex] && slides[activeIndex].dataset.slideType;
      this.lastActive && this.slider.slideToLoop(this.lastActive);
      
      // Usa o método unificado para reproduzir vídeos
      this.playCurrentVideo();
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
